import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEn from '@/translations/en/hello.json';
import commonEn from '@/translations/en/common.json';
import translationPl from '@/translations/pl/hello.json';
import commonPl from '@/translations/pl/common.json';
import translationEs from '@/translations/es/hello.json';
import commonEs from '@/translations/es/common.json';
import translationNl from '@/translations/nl/hello.json';
import commonNl from '@/translations/nl/common.json';
import translationFr from '@/translations/fr/hello.json';
import commonFr from '@/translations/fr/common.json';
import translationDe from '@/translations/de/hello.json';
import commonDe from '@/translations/de/common.json';

const LANGUAGES = {
  EN: 'en',
  PL: 'pl',
  ES: 'es',
  NL: 'nl',
  FR: 'fr',
  DE: 'de',
} as const;

export const resources = {
  [LANGUAGES.EN]: {
    translation: {
      ...translationEn,
      ...commonEn,
    },
  },
  [LANGUAGES.PL]: {
    translation: {
      ...translationPl,
      ...commonPl,
    },
  },
  [LANGUAGES.ES]: {
    translation: {
      ...translationEs,
      ...commonEs,
    },
  },
  [LANGUAGES.NL]: {
    translation: {
      ...translationNl,
      ...commonNl,
    },
  },
  [LANGUAGES.FR]: {
    translation: {
      ...translationFr,
      ...commonFr,
    },
  },
  [LANGUAGES.DE]: {
    translation: {
      ...translationDe,
      ...commonDe,
    },
  },
};

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources,
  interpolation: {
    escapeValue: false,
  },
});
